import PropTypes from 'prop-types';

const SideNavigationTemplate = ({ children, navWidth }) => {
  const columnWidth = {
    gridTemplateColumns: `${navWidth} 1fr`,
  };

  return (
    <div className="grid gap-8" style={columnWidth}>
      {children}
    </div>
  );
};

SideNavigationTemplate.defaultProps = {
  navWidth: '15.5rem',
};

SideNavigationTemplate.propTypes = {
  children: PropTypes.node.isRequired,
  navWidth: PropTypes.string,
};

export default SideNavigationTemplate;
